import type { AmazonPayCheckoutSessionResponse } from '@ctct/domain-layer';
import type { ApplePayShippingAddress } from '@ctct/infrastructure-layer';

import { EventBus } from '../../helpers';
import type { BillingInfoFormValues } from '../BillingInfoFormManager';

// we use type instead of interface to satisfy typescript's type checking
type PaymentMethodsEvents = {
  // eventName: [callbackArguments, ...]
  paypalConnected: [payload: { agreementId: string; isStripe: boolean }];
  paypalError: [payload: { error: string }];

  amazonPayConnected: [response: AmazonPayCheckoutSessionResponse];
  paymentMethodCanBeUpdated: [canBeUpdated: boolean];
  applePayIFrameLoaded: [];
  applePayConnected: [];
  applePayAborted: [];
  // applePayTaxValueReques - this event is called when securepay apple pay iframe wants to determine tax value
  // Event will be called when shouldGetTaxUpdateForApplePay = true  (it will be use for trailer / user without billing info)
  // Payload (address) should be used to make additional rating call to determine tax value,
  // then securePayService.setApplePayTaxValue(taxValue) should be called to pass tax value to securepay apple pay iframe
  applePayTaxValueRequest: [address: ApplePayShippingAddress];
  // applePayAddress - this event is called when securepay apple pay iframe sends billing address from apple pay
  // Event will be called when shouldGetAddressFromApplePay = true
  // we can use data from the payload to update Billing Info Form
  partialBillingInfoFormDataFromApplePay: [address: Partial<BillingInfoFormValues>];

  stripePostRedirectSuccess: [];
  stripePostRedirectFailure: [payload: { message: string }];
  stripePaymentMethodChanged: [payload: { paymentMethod: string }];
};

class PaymentMethodsEventBus extends EventBus<PaymentMethodsEvents> {}

export const paymentMethodsEventBus = new PaymentMethodsEventBus();
